import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import PageBack from "../components/buttons/page-back";
import {api, apis, rd, sendGet} from "../../vars/rd";
import CategoryBusiness from "../components/buttons/category.business";
import DaoChannel from "../../modules/dao/channel";
import ChannelItem from "../components/elements/channel.item";
import {preloaderHide, preloaderShow} from "../../libs/redux/actions/preloader";
import DaoCategory from "../../modules/dao/category";

class SearchBusiness extends Component {
    is_loading = false;

    scrollPosition = 0;
    scrollHandler;
    scrollRef;
    constructor(props) {
        super(props);

        this.history = props.history;

        this.scrollHandler = this.eventScroll.bind(this);

        let id = Number(props.match.params.id);
        let categories = rd.category.business ? [...rd.category.business] : [];
        let business = null;
        let channels = null;

        if(categories.length) {
            categories.forEach(
                /** @param cate {DaoCategory} */
                cate => {
                    if(cate.proid === id) {
                        cate.selected = true;
                        business = cate;
                    }
                }
            );
        }
        let business_genre = null;

        this.state = {
            id, categories, business, business_genre, channels,
            page: 0,
            page_count: 0,
            total: 0
        };
    }

    /**
     * 페이지 마운트
     */
    componentDidMount() {
        this.mounted = true;
        this.categoryChange(this.state.business);

        if(this.scrollRef) this.scrollRef.addEventListener('scroll', this.scrollHandler);
    }

    /**
     * 페이지 언마운트
     */
    componentWillUnmount() {
        this.mounted = false;
        if(this.scrollRef) this.scrollRef.removeEventListener('scroll', this.scrollHandler);
        this.scrollRef = null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        try {
            const prev_id = Number(prevProps.match.params.id);
            // noinspection JSUnresolvedReference
            const id = Number(this.props.match.params.id);

            if(id !== prev_id) {
                if(this.state.categories.length > 0) {
                    this.state.categories.forEach(
                        /** @param cate {DaoCategory} */
                        cate => {
                            if(cate.proid === id) this.categoryChange(cate);
                        }
                    );
                }
            }
        } catch (e) {}
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    /**
     * 스크롤 이벤트
     * @param e
     */
    eventScroll(e) {
        try {
            const scroller = e.currentTarget;
            if(scroller) {
                const scrollHeight = scroller.scrollHeight;
                const height = scroller.offsetHeight;
                const top = scroller.scrollTop;
                if(top > this.scrollPosition) {
                    const gap = scrollHeight - (height + top);
                    if(gap < 30) this.channelNext();
                }
                this.scrollPosition = top;
            }
        } catch (e) {}
    }

    /**
     * 카테고리 변경
     * @param business {DaoCategory} 카테고리
     */
    categoryChange = (business) => {
        if(business) {
            this.setState((pstate) => ({
                business,
                categories: pstate.categories.map(
                    /**
                     * @param cate {DaoCategory}
                     * @returns {DaoCategory}
                     */
                    cate => {
                        cate.selected = business.proid === cate.proid;
                        return cate;
                    }
                ),
            }));

            if(business.lists.length) {
                this.businessGenreChange(new DaoCategory(business.lists[0])).then();
            }
        } else {
            if(this.history) this.history.goBack();
        }
    }

    /**
     * 채널 정보변경된경우 호출
     * @param business_genre {DaoCategory}
     */
    async businessGenreChange(business_genre) {
        const p_business_genre = this.state.business_genre || new DaoCategory();
        if (business_genre && p_business_genre.proid !== business_genre.proid) {
            this.setState(
                { business_genre, page: 0, page_count: 0, total: 0, channels: [] },
                async () => {
                    await this.channelData(business_genre, 1);
                }
            );
        }
    }

    /**
     * 채널데이터 다음 페이지 존재여부
     * @returns {boolean}
     */
    get channelHasNext() {
        return this.state && ((this.state.total || 0) > (this.state.page_count || 0));
    }

    /**
     * 채널데이터 다음 인출
     * @returns
     */
    channelNext() {
        if (this.channelHasNext && !this.is_loading) {
            this.is_loading = true;
            const page = this.state.page + 1;
            this.channelData(this.state.business_genre, page).then();
        }
    }

    /**
     * 채널데이터 인출
     * @param category {DaoCategory}
     * @param page {number}
     * @returns {Promise<void>}
     */
    async channelData(category, page) {
        try {
            if(this.state.page !== page) {
                this.dispatch(preloaderShow());
                const url = api(apis.channel_lists, {
                    serviceid: rd.user.serviceid,
                    groupid: rd.user.groupid,
                    category: category.proid,
                    p: page
                });
                const json = await sendGet(url);

                if(this.mounted) {
                    const page_count = json.page_count;
                    const total = json.total;

                    this.dispatch(preloaderHide());
                    const channels = [];
                    if (json.items.length) {
                        for (let i = 0; i < json.items.length; i++) {
                            channels.push(new DaoChannel(json.items[i]));
                        }
                    }
                    this.setState({channels: [...this.state.channels, ...channels], page, page_count, total}, () => {
                        this.is_loading = false;
                    });
                }
            }
        } catch (e) {}
    }

    render() {
        return (
            <div className="search-wrap mobile-search">
                <div className="search-box2">
                    <h2>
                        <PageBack />
                        업종별 추천 채널
                    </h2>
                    <div className="search-bar">
                        <div className="recommend-type2">
                            <div className="list" role="tablist">
                                {
                                    this.state.categories && this.state.categories.map(
                                        /**
                                         * @param category {DaoCategory}
                                         * @param category_index {number}
                                         */
                                        (category, category_index) => {
                                            return (
                                                <CategoryBusiness key={category_index} category={category} onChange={this.categoryChange} />
                                            );
                                        }
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    <div className="search-bar2">
                        <div className="genre">
                            <ul className="list" role="tablist">
                                {
                                    this.state.business && this.state.business.lists.map(
                                        /**
                                         * @param category {DaoCategory}
                                         * @param category_index {number}
                                         */
                                        (category, category_index) => {
                                            category.selected = this.state.business_genre && this.state.business_genre.proid === category.proid;
                                            return (
                                                <li key={category_index}
                                                    className={`item ${category.selected ? 'on' : ''}`}
                                                    onClick={() => this.businessGenreChange(category)}>{category.proname}</li>
                                            )
                                        }
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="search-result search-result2" ref={el => {
                    this.scrollRef = el;
                }}>
                    {
                        this.state.channels && this.state.channels.map(
                            (channel, channel_index) => {
                                return <ChannelItem key={channel_index} data={channel}/>
                            }
                        )
                    }
                </div>
            </div>
        );
    }
}

export default connect()(withRouter(SearchBusiness));


// WEBPACK FOOTER //
// ./src/pages/search/business.jsx